var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"colorTextComponent"},[_c('select',{staticClass:"cmpt",on:{"change":_vm.changeColorText}},_vm._l((_vm.colors),function(color){return _c('option',{domProps:{"value":color.id,"selected":_vm.label.current_color == color.id}},[_vm._v(_vm._s(color.title))])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04677ac2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ColorText/Color.vue
// module id = 104
// module chunks = 0